// utils/timeUtils.js
/**
 * Calculates the time elapsed since the given timestamp and returns a human-readable string.
 * @param {string | number | Date} timestamp - The timestamp or date of the event.
 * @returns {string} - A string describing the elapsed time (e.g., "5 minutes ago").
 */
export const getTimeElapsed = (timestamp) => {
    if (!timestamp) {
      return "N/A"; // Handle null or undefined
    }
  
    const now = Date.now();
    const orderDate = new Date(timestamp);
  
    if (isNaN(orderDate.getTime())) {
      return "Invalid date"; // Handle invalid timestamps
    }
  
    const diffInMinutes = Math.floor((now - orderDate) / (1000 * 60));
  
    if (diffInMinutes === 0) {
      return "Just now";
    } else if (diffInMinutes < 0) {
      return "88 mph";
    } else if (diffInMinutes < 60) {
      return `${diffInMinutes} minute${diffInMinutes !== 1 ? "s" : ""} ago`;
    } else if (diffInMinutes < 24 * 60) {
      const diffInHours = Math.floor(diffInMinutes / 60);
      return `${diffInHours} hour${diffInHours !== 1 ? "s" : ""} ago`;
    } else {
      const diffInDays = Math.floor(diffInMinutes / (60 * 24));
      return `${diffInDays} day${diffInDays !== 1 ? "s" : ""} ago`;
    }
  };